import { z } from 'zod';
import { DiscountTypesSchema } from './DiscountTypes.js';

const reEngagementDiscountSchema = z.object({
    type: DiscountTypesSchema,
    amount: z.number(),
    name: z.string(),
    applicableTo: z.array(z.string()),
});
const emailReEngagementSettingSchema = z.object({
    hourDelay: z.number(),
    discount: reEngagementDiscountSchema.optional(),
});
const emailReEngagementConfigSchema = z.object({
    disabled: z.boolean().optional(),
    reEngagementSettings: z.array(emailReEngagementSettingSchema).optional(),
});
const reEngagementConfigSchema = z.object({
    disabled: z.boolean().optional(),
    EMAIL: emailReEngagementConfigSchema.optional(),
    SMS: z.record(z.unknown()).optional(), // To be filled out as we better understand use case
});

export { reEngagementConfigSchema };
//# sourceMappingURL=ReEngagementConfig.js.map
